import { commentaryData, liveInningData, oversData } from '@/graphql/match'
import { gql } from '@apollo/client'

export const FULL_SCOREBOARD = gql`
  query FetchLiveInningsData($scorecard: liveInningsInput) {
    fetchLiveInningsData(input: $scorecard) {
      iBattingTeamId
      aActiveBatters {
        oBatter {
          isCaptain
          isWk
          bImpactPlayer
          sFullName
          sShortName
          sTitle
          eTagStatus
          oSeo {
            sSlug
          }
        }
        nSixes
        nRuns
        nFours
        nBallFaced
        sStrikeRate
        iBatterId
      }
      aActiveBowlers {
        oBowler {
          isCaptain
          isWk
          bImpactPlayer
          sFullName
          eTagStatus
          oSeo {
            sSlug
          }
        }
        sEcon
        sOvers
        nWickets
        nRunsConceded
        nMaidens
        iBowlerId
      }
      aBatters {
        bIsBatting
        eDismissal
        nBallFaced
        nFours
        nRuns
        nSixes
        oCommentary {
          sComSummary
          sCommentary
          sBall
          sEventId
          nRuns
          eEvent
          bIsGptCommentary
          sGptCommentary
          sOver
          sHowOut
          sScore
          sText
        }
        oBatter {
          isCaptain
          isWk
          bImpactPlayer
          sShortName
          sFullName
          eTagStatus
          oSeo {
            sSlug
          }
        }
        sHowOut
        sStrikeRate
        iBatterId
      }
      aBowlers {
        bIsBowling
        nMaidens
        oBowler {
          isCaptain
          isWk
          bImpactPlayer
          sShortName
          sFullName
          eTagStatus
          oSeo {
            sSlug
          }
        }
        nWickets
        sEcon
        sOvers
        nNoBalls
        nWides
        nRunsConceded
        iBowlerId
      }
      aFOWs {
        nScoreDismissal
        nWicketNumber
        oBatter {
          sShortName
          sFullName
          eTagStatus
          oSeo {
            sSlug
          }
        }
        sOverDismissal
        iBatterId
      }
      nInningNumber
      oExtraRuns {
        nByes
        nWides
        nNoBalls
        nLegByes
        nTotal
        nPenalty
      }
      sName
      sShortName
      sResultStr
      oEquations {
        nRuns
        nWickets
        sOvers
        sRunRate
      }
    }
  }
`

export const LIVE_INNING_DATA = gql`
  query FetchLiveInningsData($input: liveInningsInput) {
    fetchLiveInningsData(input: $input) {
      ${liveInningData}
    }
  }
`

export const MATCH_DETAIL = gql`
  query GetMatchById($input: oGetMatchByIdInput) {
    getMatchById(input: $input) {
      _id
      dEndDate
      bIsCommentary
      iEventId
      aTopPerformers {
        aPlayers {
          oPlayer {
            _id
            sFullName
            sShortName
            oSeo {
              eStatus
              sSlug
            }
            oImg {
              sUrl
              sText
              sCaption
            }
            sCountry
            sCountryFull
          }
          sStat
          sSubTitle
        }
        sTitle
        sSubTitle
        nInningNumber
      }
      oReview {
        aBattingReview {
          sTitle
          sBattingTeamTotalReview
          sBattingTeamReviewSuccess
          sBattingTeamReviewFailed
          sBattingTeamReviewAvailable
          sBattingTeamReviewRetained
          iTeamId
        }
        aBowlingReview {
          sTitle
          sBowlingTeamTotalReview
          sBowlingTeamReviewSuccess
          sBowlingTeamReviewFailed
          sBowlingTeamReviewAvailable
          sBowlingTeamReviewRetained
          iTeamId
        }
      }
      oSummary {
        nInningNumber
        aSummaryGraph {
          sTitle
          aWickets {
            nOver
            nWickets
          }
          nRuns
        }
      }
      sessions {
        runs
        title
        yes
        max
        no
        min
        status
      }
      odds {
        favOdds {
          title
          back
          lay
        }
        allOdds {
          title
          back
          lay
        }
      }
      featuredSessions {
        runs
        title
        yes
        max
        no
        min
        status
        over
        open
        description
      }
      #      oCricTezzPrediction {
      #        sessionPredict {
      #          sS_over
      #          sS_min
      #          sS_max
      #        }
      #        winPredict {
      #          sMin_rate
      #          sMax_rate
      #          sFav_team_text
      #        }
      #        inningScore {
      #          sInning_max
      #          sInning_min
      #          sInning_ovr
      #        }
      #        runBalls {
      #          runs
      #          balls
      #        }
      #      }
      oSeo {
        sSlug
        sTitle
        sRobots
        sDescription
        sCUrl
        oTwitter {
          sUrl
          sTitle
          sDescription
        }
        oFB {
          sUrl
          sTitle
          sDescription
        }
        eType
        eStatus
        aKeywords
        _id
        iId
      }
      sProjectScore
      sResult
      nLatestInningNumber
      sDescription
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      dStartDate
      oSeries {
        sAbbr
        sSeason
        sTitle
        sStatus
        nTotalTeams
        _id
        oSeo {
          sSlug
        }
        oCategory {
          oSeo {
            sSlug
          }
          oImg {
            sUrl
            sText
          }
        }
      }
      oWinner {
        _id
      }
      sBallEvent
      #      oCricTezzScore {
      #        sFirstCircle
      #      }
      oTeamScoreA {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          oSeo {
            sSlug
            eStatus
          }
          sTitle
        }
      }
      oVenue {
        sLocation
        sName
      }
      oToss {
        sText
        oWinnerTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
        }
        eDecision
      }
      oTeamScoreB {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          oSeo {
            sSlug
            eStatus
          }
          sTitle
        }
      }
      oLiveScore {
        nRuns
        nTarget
        oTeam {
          sTitle
          sAbbr
        }
        nRunrate
        nWickets
        sOvers
      }
      aInning {
        sShortName
        nInningNumber
        oBattingTeam {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
        iBattingTeamId
        bSuperOver
      }
      oMom {
        sFullName
        sThumbUrl
        eTagStatus
        oImg {
          sUrl
        }
        oSeo {
          sSlug
        }
      }
      oMos {
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
      oWeatherInfo {
        sUrl
        sWeatherTitle
        sWeatherDescription
        sTemperature
        sHumidity
        sVisibility
        sWindSpeed
        sClouds
      }
      oPitchInformation {
        sUrl
        sPitchCondition
        sBattingCondition
        sPaceBowlingCondition
        sSpineBowlingCondition
      }
      sUmpires
      sReferee
      oWinPercent {
        sTitle
        sWinPercentage
      }
    }
  }
`

export const GET_FANTASY_PLATFORM = gql`
  query GetFantasyTipsFront($input: oGetFantasyTipsFrontInput) {
    getFantasyTipsFront(input: $input) {
      _id
      oSeo {
        sSlug
      }
      oTeamB {
        sTitle
        _id
      }
      oTeamA {
        sTitle
        _id
      }
      dUpdated
      aLeague {
        aTeam {
          aSelectedPlayerFan {
            _id
            oTeam {
              sTitle
              _id
            }
            oPlayer {
              sFullName
              sFirstName
              sPlayingRole
              sShortName
            }
            nRating
            eRole
          }
          oTeamA {
            nCount
            oTeam {
              sAbbr
              sTitle
            }
          }
          oTeamB {
            nCount
            oTeam {
              sAbbr
              sTitle
            }
          }
          oCapFan {
            _id
          }
          oVCFan {
            _id
          }
          oTPFan {
            _id
          }
        }
        eLeague
      }
    }
  }
`

export const GET_COMMENTARY = gql`
query ListMatchCommentaries($commentary: oListMatchCommentaryFrontInput) {
  listMatchCommentaries(input: $commentary) {
    ${commentaryData}
  }
}
`

export const GET_MATCH_OVERVIEW = gql`
  query MatchOverviewFrontData($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      aCricPrediction {
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          bIsForeign
          oPlayer {
            eTagStatus
            sFullName
            sFirstName
            oImg {
              sUrl
            }
            oSeo {
              sSlug
              eStatus
            }
          }
          bIn
          bOut
          sRoleStr
          isCaptain
          isWicketKeeper
        }
        oTeam {
          sTitle
          sAbbr
          _id
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          bIsForeign
          oPlayer {
            eTagStatus
            sFullName
            sFirstName
            oImg {
              sUrl
            }
            oSeo {
              sSlug
              eStatus
            }
          }
          bIn
          bOut
          sRoleStr
          isCaptain
          isWicketKeeper
        }
        oTeam {
          sTitle
          sAbbr
          _id
        }
      }
      sMatchPreview
      sPitchCondition
      sWeatherReport
      sAvgScore
      oWinnerTeam {
        sTitle
      }
    }
  }
`

export const GET_MATCH_PLAYING_XI = gql`
  query GetMatchOverviewFrontPlayingXI($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          isWicketKeeper
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oSeo {
              sSlug
            }
          }
          bOut
          bIsForeign
          sRoleStr
          isCaptain
        }
        oTeam {
          _id
          sAbbr
          sTitle
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          isWicketKeeper
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oSeo {
              sSlug
            }
          }
          bOut
          bIsForeign
          sRoleStr
          isCaptain
        }
        oTeam {
          _id
          sAbbr
          sTitle
        }
      }
    }
  }
`

export const GET_TEAM_FORM = gql`
  query GetTeamForm($teamForm: getTeamFormInput) {
    getTeamForm(input: $teamForm) {
      _id
      dStartDate
      sDescription
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      oSeries {
        oCategory {
          sName
        }
      }
      sStatusNote
      sResult
      sReferee
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      oSeo {
        sSlug
      }
      oTeamScoreA {
        oTeam {
          _id
          sTitle
          oImg {
            sAttribute
            sUrl
          }
          sAbbr
        }
        sOvers
        sScores
        sScoresFull
      }
      oWinner {
        _id
        sTitle
        sAbbr
        oImg {
          sText
          sCaption
          sAttribute
          sUrl
        }
      }
      oTeamScoreB {
        oTeam {
          _id
          oImg {
            sAttribute
            sUrl
          }
          sAbbr
          sTitle
        }
        sOvers
        sScores
        sScoresFull
      }
    }
  }
`
export const GET_HEAD_TO_HEAD = gql`
  query GetHeadToHead($input: getHeadToHeadInput) {
    getHeadToHead(input: $input) {
      oMatchSeos {
        oSeo {
          eSubType
        }
      }
      sWinMargin
      sUmpires
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sResult
      oSeo {
        sSlug
      }
      sReferee
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      oWinner {
        sTitle
        sAbbr
        _id
      }
      oTeamScoreA {
        oTeam {
          sAbbr
          sTitle
          oImg {
            sUrl
          }
        }
        sScores
        sScoresFull
        sOvers
      }
      oTeamScoreB {
        oTeam {
          sTitle
          sAbbr
          oImg {
            sUrl
          }
        }
        sOvers
        sScores
        sScoresFull
      }
    }
  }
`

export const GET_MATCH_SQUAD = gql`
  query ListMatchSquad($matchSquad: oListMatchSquadInput) {
    listMatchSquad(input: $matchSquad) {
      bPlaying11
      bSubstitute
      iPlayerId
      oTeam {
        sAbbr
        sTitle
        _id
      }
      sName
      sRoleStr
    }
  }
`

export const RECENT_OVER = gql`
query ListMatchOvers($input: oListMatchOverFrontInput) {
  listMatchOvers(input: $input) {
    nTotal
    aResults {
      ${oversData}
    }
  }
}
`

export const GET_MATCH_STATS = gql`
  query GetMatchStatistics($input: getMatchStatisticsInput) {
    getMatchStatistics(input: $input) {
      aWorm {
        nOver
        nRuns
      }
      aPartnership {
        nBallFaced
        nRuns
        nOrder
        aBatsmen {
          oBatter {
            sShortName
          }
          nBallFaced
          nRuns
          nFours
          nSixes
        }
      }
      nInningNumber
      nRuns
      nWickets
      sName
      sOvers
      sBalls
      aManhattan {
        nRuns
        nOver
        nWickets
      }
      aRunRates {
        nRunRate
        nOver
      }
      aRunTypes {
        sValue
        sName
        sKey
      }
      aWickets {
        sValue
        sName
        sKey
      }
      aExtras {
        sValue
        sName
        sKey
      }
    }
  }
`

export const GET_MATCH_ODDS = gql`
  query GetOddsHistoryByMatchId($input: oGetOddsHistoryInput) {
    getOddsHistoryByMatchId(input: $input) {
      oOddsWinPercentage {
        aWinPercentage {
          aPercent {
            sWinPercentage
            iTeamId
          }
          bIsWicket
          iPlayerId
          nRuns
          nWickets
          oPlayer {
            sFullName
          }
          sOvers
          sScoresFull
        }
        nInningNumber
      }
      firstInningData {
        sScore
        sOver
        sSessionText
        sSessionMin
        sSessionMax
        sFavTeam
        sWinRateMin
        sWinRateMax
        odds {
          favOdds {
            title
            back
            lay
          }
        }
      }
      secondInningData {
        sScore
        sOver
        sSessionText
        sSessionMin
        sSessionMax
        sFavTeam
        sWinRateMin
        sWinRateMax
        odds {
          favOdds {
            title
            back
            lay
          }
        }
      }
      thirdInningData {
        sScore
        sOver
        sSessionText
        sSessionMin
        sSessionMax
        sFavTeam
        sWinRateMin
        sWinRateMax
        odds {
          favOdds {
            title
            back
            lay
          }
        }
      }
      forthInningData {
        sScore
        sOver
        sSessionText
        sSessionMin
        sSessionMax
        sFavTeam
        sWinRateMin
        sWinRateMax
        odds {
          favOdds {
            title
            back
            lay
          }
        }
      }
    }
  }
`

export const GET_FANTASY_OVERVIEW = gql`
  query GetOverviewFront($input: oGetOverviewFrontInput) {
    getOverviewFront(input: $input) {
      aCricPrediction {
        _id
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aBenchedPlayers {
          sShortName
          sPlayingRole
          oSeo {
            sSlug
          }
          _id
        }
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          oSeo {
            sSlug
          }
          _id
        }
        iC
      }
      oTeam2 {
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          oSeo {
            sSlug
          }
          _id
        }
        iC
        aBenchedPlayers {
          _id
          sPlayingRole
          oSeo {
            sSlug
          }
          sShortName
        }
      }
      sMatchPreview
      sNews
      sPitchCondition
      sPitchReport
      sWeatherReport
      sWeatherCondition
      sAvgScore
    }
  }
`

export const GET_WAGON_WHEEL_DATA = gql`
  query GetWagonsData($input: getWagonsDataInput) {
    getWagonsData(input: $input) {
      runs {
        offSide
        onSide
        total
        types {
          type
          list {
            nXcord
            nYcord
          }
          count
        }
      }
      zones {
        runsScored
        zone
      }
      isCoordinate
      isZone
    }
  }
`

export const GET_VENUE_STATS = gql`
  query GetVenueStatsByMatchId($input: getVenueStatsByMatchIdInput) {
    getVenueStatsByMatchId(input: $input) {
      iVenueId
      nWicketsPace
      nWicketsSpin
      aStatsPerInning {
        nInningNumber
        nAvgRuns
      }
      oHighestScore {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          sResult
          oTeamScoreA {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
        }
      }
      oHighestScoreChased {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          sResult
          oTeamScoreA {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
        }
      }
      oLowestScore {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          sResult
          oTeamScoreA {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            sScores

            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
        }
      }
      oLowestScoreDefended {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          sResult
          oTeamScoreA {
            iTeamId
            sOvers
            sScores
            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            sScores
            oTeam {
              sCountry
              sAbbr
              oImg {
                sUrl
              }
            }
          }
        }
      }
      nTotalMatches
      nFirstBatWin
      nFirstBowlWin
    }
  }
`

export const GET_RECENT_MATCHES_STATS = gql`
  query GetRecentStatsOfTeam($input: getRecentStatsOfTeamInput) {
    getRecentStatsOfTeam(input: $input) {
      nTotalMatches
      nAverageScore
      nLowestScore {
        nRuns
      }
      nHighestScore {
        nRuns
      }
      nTotalWinsPer
      oTeam {
        oImg {
          sUrl
        }
        sAbbr
        oSeo {
          sSlug
          eStatus
        }
      }
    }
  }
`

export const GET_FEATURED_SESSION_STATS = gql`
  query GetFeaturedSessionsByMatchId($input: getFeaturedSessionsByMatchIdInput) {
    getFeaturedSessionsByMatchId(input: $input) {
      aSessions {
        sTitle
        sBack
        sLay
        sMax
        sMin
        sOpen
        sOver
        sPass
        sStatus
      }
      nInningNumber
      iMatchId
      iBattingTeamId
    }
  }
`

export const GET_MATCHES_DATA = gql`
  query ListAllFixturesMobileV2($input: listAllFixturesMobileInput) {
    listAllFixturesMobileV2(input: $input) {
      _id
      dStartDate
      sWinMargin
      sUmpires
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sResult
      oSeo {
        sSlug
      }
      sReferee
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      oWinner {
        sTitle
        sAbbr
        _id
      }
      oTeamScoreA {
        oTeam {
          sAbbr
          sTitle
          oImg {
            sUrl
          }
        }
        sScores
        sScoresFull
        sOvers
      }
      oTeamScoreB {
        oTeam {
          sTitle
          sAbbr
          oImg {
            sUrl
          }
        }
        sOvers
        sScores
        sScoresFull
      }
    }
  }
`

export const GET_NEWS_DATA_BY_MATCH = gql`
  query GetNewsByMatchId($input: getNewsByMatchIdInput) {
    getNewsByMatchId(input: $input) {
      aResults {
        _id
        sTitle
        sSubtitle
        nDuration
        dPublishDisplayDate
        dPublishDate
        oImg {
          sUrl
          sText
        }
        oSeo {
          sSlug
          eStatus
        }
      }
    }
  }
`
